module.exports = __webpack_public_path__ + "img/close_icon.15f1f436.svg";